document.addEventListener('submit', async function (event) {
  const form = event.target.closest('.sx-ajax-product-form');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('.sx-add-btn');
  const text = form.querySelector('[data-sx-add-text]');

  if (!button || button.disabled) return;

  const originalText = text ? text.textContent : 'ADD TO CART';

  button.classList.add('is-loading');
  button.disabled = true;

  if (text) text.textContent = 'ADDING...';

  try {
    const formData = new FormData(form);

    const cartElement =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      const sections = cartElement.getSectionsToRender().map(function (section) {
        return section.id;
      });

      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Cart error');
    }

    if (cartElement && typeof cartElement.renderContents === 'function') {
      cartElement.renderContents(data);
    }

    await updateSxCartCount();

    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.disabled = false;

    if (text) text.textContent = 'ADDED';

    setTimeout(function () {
      button.classList.remove('is-added');
      if (text) text.textContent = originalText;
    }, 1400);

  } catch (error) {
    console.error(error);

    button.classList.remove('is-loading');
    button.disabled = false;

    if (text) text.textContent = 'ERROR';

    setTimeout(function () {
      if (text) text.textContent = originalText;
    }, 1600);
  }
});

async function updateSxCartCount() {
  try {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    const cart = await response.json();

    const countSelectors = [
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span:first-child',
      '[data-cart-count]',
      '.cart-count'
    ];

    countSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      if (cart.item_count > 0) {
        bubble.style.display = '';
      }
    });

  } catch (error) {
    console.error(error);
  }
}